<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="10" lg="8">
        <b-card>
          <div slot="header">Job Position / Pangkat 
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            show-empty
            @row-clicked="rowClicked"
          >
            <template #empty="scope">
              <h6 class="text-center">{{ scope.emptyText }}</h6>
            </template>
            <template #emptyfiltered="scope">
              <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
            </template>
            <template v-slot:cell(index)="data">
              {{ data.index +1}}
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        </b-col>
    </b-row>

    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Job Position - Add/Edit Form </div>
              <b-form-group  label-cols=3  label="Code" >
                  <b-form-input v-model="frmdata.pangkatkd" :state="!$v.frmdata.pangkatkd.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Name" >
                  <b-form-input v-model="frmdata.pangkat" :state="!$v.frmdata.pangkat.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Number" >
                  <b-form-input v-model="frmdata.pangkatno" :state="!$v.frmdata.pangkatno.$error"></b-form-input>
              </b-form-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
  </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        pangkatkd: { required },
        pangkat: { required },
        pangkatno: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{pangkat: '' },
      tblData: {
        tablename:'job-position',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'pangkat',
        sortDesc: false
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "pangkatkd",
            label: "Code",
            sortable: true
          },
          {
            key: "pangkat",
            label: "Name",
            sortable: true
          },
          {
            key: "pangkatno",
            label: "Number",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.pangkatid;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'job-position', 
                     key:this.frmdata.idlama, 
                     data:{pangkatkd:this.frmdata.pangkatkd, pangkat:this.frmdata.pangkat, pangkatno:this.frmdata.pangkatno}
                      });
              } else {
                await crud.insert(
                  { tablename:'job-position',                      
                     data:{pangkatkd:this.frmdata.pangkatkd, pangkat:this.frmdata.pangkat, pangkatno:this.frmdata.pangkatno}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'job-position', key:this.model.pangkatid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
